import { API_URL } from "../config"
import { getToken } from "../util/validation"

const token = JSON.parse(getToken);

export async function addGoogleLicense(domain_name, subscription_id, customer_id, seats, plan_name, addedSeats){
    try {
        const email = localStorage.getItem('user')
        var payload = {
            'email': email,
            'domain_name': domain_name,
            'subscription_id':subscription_id,
            'customer_id' : customer_id,
            'seats' : seats,
            'plan_name': plan_name,
            'added_seats': addedSeats
        }
        console.log(payload,"[ayload")
        const response = await fetch(API_URL + 'add_google_license/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(payload),
        });
        
        if (response.status === 200 || response.status === 201) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }
}

export async function getTransactionReportData(month){
     try {
    
            const email = localStorage.getItem('user')
            var data = {
                'email': email,
                'month': month
            }
    
            const response = await fetch(API_URL + 'adminpanel/get_admin_add_license_report/', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token.login_token
                },
                body: JSON.stringify(data),
            });
            
            if (response.status === 200) {
    
                return response.json()
            }
            else{
                
                return false
            }
    
        } catch (error) {
            return false
        }
    }

